export const PROFILE_ASPECT = 16 / 7;
export const PROFILE_OUTPUT_WIDTH = 1600;
export const PROFILE_OUTPUT_HEIGHT = 700;

export const CARD_ASPECT = 4 / 5;
export const CARD_OUTPUT_WIDTH = 800;
export const CARD_OUTPUT_HEIGHT = 1000;

export const MAX_IMAGE_SIZE_MB = 8;
export const MAX_IMAGE_SIZE_BYTES = MAX_IMAGE_SIZE_MB * 1024 * 1024;
export const ACCEPTED_IMAGE_TYPES = ['image/jpeg', 'image/png', 'image/webp'];

export const COVER_EDITOR_STEPS = [
  { id: 'upload', label: 'Cargar' },
  { id: 'profile', label: 'Portada' },
  { id: 'review', label: 'Revisión' },
] as const;

export const CARD_EDITOR_STEPS = [
  { id: 'upload', label: 'Cargar' },
  { id: 'card', label: 'Foto' },
  { id: 'review', label: 'Revisión' },
] as const;
